import Swiper, {Pagination, Navigation} from 'swiper/core';
import {sliderPaginationConfiguration} from '../Slider/Slider';

// configure Swiper to use modules
Swiper.use([Navigation, Pagination]);

export class HowToVideosController {
  private listElements = document.querySelectorAll('.js-listWithFilters');
  private activeClass = 'list__filterItem--active';
  private inactiveClass = 'list__filterItem--inactive';

  constructor() {
    if (this.listElements.length < 1) {
      return;
    }
    this.listElements.forEach((list: HTMLElement) => {
      this.addListeners(list);
      this.filter(list, true);
      this.initSliders(list);
    });
  }

  addListeners(list: HTMLElement) {
    list.querySelectorAll('.js-videoCategory').forEach((categoryElem) => {
      categoryElem.addEventListener('click', () => {
        if (!categoryElem.classList.contains(this.inactiveClass)) {
          categoryElem.classList.toggle(this.activeClass);
          this.filter(list);
        }
      });
    });
    list.querySelectorAll('.js-videoLanguage').forEach((languageElem) => {
      languageElem.addEventListener('click', () => {
        if (!languageElem.classList.contains(this.inactiveClass)) {
          languageElem.classList.toggle(this.activeClass);
          this.filter(list);
        }
      });
    });
  }

  handleSliderArrows(list: HTMLElement) {
    const firstElemImage: HTMLElement | null = list.querySelector('.js-listItem .js-aspectRatio');
    const arrowPrev: HTMLElement | null = list.querySelector('.swiper-button-prev');
    const arrowNext: HTMLElement | null = list.querySelector('.swiper-button-next');
    if (!firstElemImage || !arrowPrev || !arrowNext) {
      return;
    }
    let topForArrows = firstElemImage.clientHeight / 2 + 50;
    if (list.classList.contains('js-videoSeries--howTo')) {
      topForArrows -= 32;
    }
    arrowPrev.style.top = topForArrows + 'px';
    arrowNext.style.top = topForArrows + 'px';
  }

  filter(list: HTMLElement, initial = false) {
    const videos = list.querySelectorAll('.js-listItem');
    const series: NodeListOf<HTMLElement> = list.querySelectorAll('.js-videoSeries');

    videos.forEach((video) => {
      if (!(video instanceof HTMLElement)) {
        return;
      }
      const category = (video.dataset.category ?? '').split(',');
      const parentCategory = (video.dataset.parentCategory ?? '').split(',');
      const language = (video.dataset.language ?? '').split(',');
      const categories = this.getSelectedCategories(list);
      const hasCategory = this.hasOneOf(category, categories) || this.hasOneOf(parentCategory, categories);
      const hasLanguage = this.hasOneOf(language, this.getSelectedLanguages(list));

      if (hasCategory && hasLanguage) {
        video.classList.remove('hide');
      } else {
        video.classList.add('hide');
      }
    });

    // hide series completely if there is no video left to show after filtering
    series.forEach((singleSeries) => {
      const seriesVideo: NodeListOf<HTMLElement> = singleSeries.querySelectorAll('.js-listItem');
      let hide = true;

      for (let i = 0; i < seriesVideo.length; i++) {
        if (!seriesVideo[i].classList.contains('hide')) {
          hide = false;
          i = seriesVideo.length;
        }
      }

      if (hide) {
        singleSeries.classList.add('hide');
      } else {
        singleSeries.classList.remove('hide');
      }
    });
    this.handleButtonInactiveStates(list, initial);
  }

  hasOneOf(needles: string[], haystack: string[]): boolean {
    if (haystack.length === 0) {
      return true;
    }
    if (needles.length === 0) {
      return false;
    }

    let matchFound = false;
    needles.forEach((needle) => {
      if (haystack.indexOf(needle) >= 0) {
        matchFound = true;
      }
    });
    return matchFound;
  }

  getSelectedCategories(list: HTMLElement): string[] {
    const selectedCategories: string[] = [];
    list.querySelectorAll('.js-videoCategory').forEach((categoryElem) => {
      if (categoryElem instanceof HTMLElement && categoryElem.classList.contains(this.activeClass) && categoryElem.dataset.category) {
        selectedCategories.push(categoryElem.dataset.category);
      }
    });
    return selectedCategories;
  }

  getSelectedLanguages(list: HTMLElement): string[] {
    const selectedLanguages: string[] = [];
    list.querySelectorAll('.js-videoLanguage').forEach((languageElem) => {
      if (languageElem instanceof HTMLElement && languageElem.classList.contains(this.activeClass) && languageElem.dataset.language) {
        selectedLanguages.push(languageElem.dataset.language);
      }
    });
    return selectedLanguages;
  }

  handleButtonInactiveStates(list: HTMLElement, initial = false) {
    list.querySelectorAll('.js-videoCategory').forEach((categoryElem) => {
      let activeState = false;
      const videos = list.querySelectorAll('.js-listItem');
      videos.forEach((video) => {
        if (!(video instanceof HTMLElement)) {
          return;
        }
        const category = (video.dataset.category ?? '').split(',');
        const parentCategory = (video.dataset.parentCategory ?? '').split(',');
        const language = (video.dataset.language ?? '').split(',');
        let categories = this.getSelectedCategories(list);
        if (categoryElem instanceof HTMLElement && categoryElem.dataset.category) {
          categories.push(categoryElem.dataset.category);
        }
        const hasCategory = this.hasOneOf(category, categories) || this.hasOneOf(parentCategory, categories);
        const hasLanguage = this.hasOneOf(language, this.getSelectedLanguages(list));
        if (hasCategory && hasLanguage) {
          activeState = true;
        }
      });
      if (activeState) {
        categoryElem.classList.remove(this.inactiveClass);
      } else {
        if (initial) {
          categoryElem.classList.add('hide');
        } else {
          categoryElem.classList.add(this.inactiveClass);
        }
      }
    });

    list.querySelectorAll('.js-videoLanguage').forEach((languageElem) => {
      let activeState = false;
      const videos = document.querySelectorAll('.js-listItem');
      videos.forEach((video) => {
        if (!(video instanceof HTMLElement)) {
          return;
        }
        const category = (video.dataset.category ?? '').split(',');
        const language = (video.dataset.language ?? '').split(',');
        const parentCategory = (video.dataset.parentCategory ?? '').split(',');
        const categories = this.getSelectedCategories(list);
        const hasCategory = this.hasOneOf(category, categories) || this.hasOneOf(parentCategory, categories);
        let languages = this.getSelectedLanguages(list);
        if (languageElem instanceof HTMLElement && languageElem.dataset.language) {
          languages.push(languageElem.dataset.language);
        }
        const hasLanguage = this.hasOneOf(language, languages);
        if (hasCategory && hasLanguage) {
          activeState = true;
        }
      });
      if (activeState) {
        languageElem.classList.remove(this.inactiveClass);
      } else {
        languageElem.classList.add(this.inactiveClass);
      }
    });
  }

  initSliders(list: HTMLElement) {
    const series: NodeListOf<HTMLElement> = list.querySelectorAll('.js-videoSeries');

    series.forEach((singleSeries) => {
      const sliderContainer: HTMLElement | null = singleSeries.querySelector('.js-howtovideoSlider');
      const nextButton: HTMLElement | null = singleSeries.querySelector('.swiper-button-next');
      const prevButton: HTMLElement | null = singleSeries.querySelector('.swiper-button-prev');
      let breakpoints: any = {
        320: {
          slidesPerView: 1,
        },
        768: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 4,
        },
      };
      if (document.querySelector('.page--anchorNavigation')) {
        breakpoints = {
          320: {
            slidesPerView: 1,
          },
          768: {
            slidesPerView: 2,
          },
          1024: {
            slidesPerView: 2,
          },
          1450: {
            slidesPerView: 4,
          },
        };
      }
      if (sliderContainer && nextButton && prevButton) {
        const slider = new Swiper(sliderContainer, {
          slidesPerView: 4,
          watchOverflow: true,
          breakpoints: breakpoints,
          navigation: {
            nextEl: nextButton,
            prevEl: prevButton,
          },
          pagination: sliderPaginationConfiguration,
        });

        // update pagination after slider is initialized because element is hide before
        window.setTimeout(
          () => {
            slider.pagination.update();
        },
          100);
      }

      window.addEventListener('resize', () => {
        this.handleSliderArrows(singleSeries);
      });

      window.setTimeout(
        () => {
          this.handleSliderArrows(singleSeries);
        },
        100);
    });
  }
}
